import { Skeleton, Stack } from '@mui/material';

export function DetailPageSkeleton() {
  return (
    <Stack spacing={2}>
      <Skeleton variant="text" width="35%" height={40} />
      <Skeleton variant="text" width="20%" />
      <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
      <Stack direction="row" spacing={2}>
        <Skeleton variant="rectangular" width="50%" height={100} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rectangular" width="50%" height={100} sx={{ borderRadius: 2 }} />
      </Stack>
    </Stack>
  );
}
